import { UserIcon } from "@heroicons/react/24/solid";
import { AnswerBubble } from "../messages";
import { ProviderIcon, getProviderFromModelKey } from "../utils/modelIcons";

function formatModelName(modelKey) {
  if (!modelKey) return "";
  return modelKey.includes("/") ? modelKey.split("/").pop() : modelKey;
}

const renderPublicThread = ({
  messages,
  onToggleLike,
  onToggleDislike,
  onToggleCatalog,
  onRetry,
  isStreaming,
  onOpenInEditor,
  onSourceClick,
  isRightOpen,
  activeSourceId,
  citationInteractions,
}) => {
  if (!messages || messages.length === 0) return [];

  const lastAnswerIdx = messages.reduce(
    (acc, m, i) => (m.type === "answer" ? i : acc),
    -1,
  );

  const elements = [];

  for (let i = 0; i < messages.length; i++) {
    const msg = messages[i];

    if (msg.type === "question") {
      const answer =
        messages[i + 1]?.type === "answer" ? messages[i + 1] : null;

      if (answer) {
        elements.push(
          <div key={msg.id} className="group/qa flex gap-3">
            <div className="flex flex-col items-center flex-shrink-0">
              <div className="h-8 w-8 rounded-full bg-surface/80 border border-inputBorder flex items-center justify-center">
                <UserIcon className="h-4 w-4 text-mutedText" />
              </div>
              <div className="flex-1 w-px bg-surfaceBorder mt-1.5 mb-1" />
            </div>
            <div className="flex-1 min-w-0 flex flex-col gap-4">
              <div className="pt-1 pb-1 max-w-[720px]">
                <p className="text-sm font-normal leading-relaxed text-mainText">
                  {msg.question}
                </p>
              </div>
              <div className="-mt-2">
                <span className="inline-flex items-center gap-1.5 text-xs font-normal text-mutedText">
                  <ProviderIcon
                    provider={getProviderFromModelKey(answer.agent)}
                    size={15}
                  />
                  <span>{formatModelName(answer.agent)}</span>
                </span>
              </div>
              <AnswerBubble
                entry={answer}
                onToggleLike={onToggleLike}
                onToggleDislike={onToggleDislike}
                onToggleCatalog={onToggleCatalog}
                onRetry={onRetry}
                onSourceClick={onSourceClick || (() => {})}
                isRightOpen={isRightOpen || false}
                isNewest={i + 1 === lastAnswerIdx}
                isStreaming={isStreaming}
                activeSourceId={activeSourceId || null}
                citationInteractions={citationInteractions || {}}
                onOpenInEditor={onOpenInEditor}
              />
            </div>
          </div>,
        );
        i++;
      } else {
        elements.push(
          <div
            key={msg.id}
            className="group/qa flex gap-3"
            data-orphan-question="true"
          >
            <div className="flex flex-col items-center flex-shrink-0">
              <div className="h-8 w-8 rounded-full bg-surface/80 border border-inputBorder flex items-center justify-center">
                <UserIcon className="h-4 w-4 text-mutedText" />
              </div>
              <div className="flex-1 w-px bg-surfaceBorder mt-1.5 mb-1" />
            </div>
            <div className="flex-1 min-w-0 pt-1 pb-1 max-w-[720px]">
              <p className="text-sm font-normal leading-relaxed text-mainText">
                {msg.question}
              </p>
            </div>
          </div>,
        );
      }
      continue;
    }

    if (msg.type === "answer") {
      elements.push(
        <div key={msg.id} className="group/qa">
          <div className="mb-1.5">
            <span className="inline-flex items-center gap-1.5 text-xs font-normal text-mutedText">
              <ProviderIcon
                provider={getProviderFromModelKey(msg.agent)}
                size={15}
              />
              <span>{formatModelName(msg.agent)}</span>
            </span>
          </div>
          <AnswerBubble
            entry={msg}
            onToggleLike={onToggleLike}
            onToggleDislike={onToggleDislike}
            onToggleCatalog={onToggleCatalog}
            onRetry={onRetry}
            onSourceClick={onSourceClick || (() => {})}
            isRightOpen={isRightOpen || false}
            isNewest={i === lastAnswerIdx}
            isStreaming={isStreaming}
            activeSourceId={activeSourceId || null}
            citationInteractions={citationInteractions || {}}
            onOpenInEditor={onOpenInEditor}
          />
        </div>,
      );
    }
  }

  return elements;
};

export default renderPublicThread;
